import { render, staticRenderFns } from "./SiteNavigationDrawer.vue?vue&type=template&id=34580f32"
import script from "./SiteNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./SiteNavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./SiteNavigationDrawer.vue?vue&type=style&index=0&id=34580f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports